module.exports = __webpack_public_path__ + "static/media/faq_add_icon.dc081f8d.svg";